const BADGE_SELECTOR = '[data-place-badge]';
const STATE = 'tooltip';

const tooltipOf = badge => badge.querySelector('.c-badge__tooltip');

const isShown = badge =>
  getComputedStyle(tooltipOf(badge)).visibility === 'visible';

const reset = badge => {
  delete badge.dataset[STATE];
};

const resetAll = except => {
  document.querySelectorAll(BADGE_SELECTOR).forEach(badge => {
    if (badge !== except) reset(badge);
  });
};

const canHover = () => window.matchMedia('(hover: hover)').matches;

document.addEventListener('click', event => {
  const badge = event.target.closest(BADGE_SELECTOR);

  resetAll(badge);
  if (!badge) return;

  // A pointer click on a hover-capable device only repeats what the hover already shows.
  if (event.detail > 0 && canHover()) return;

  badge.dataset[STATE] = isShown(badge) ? 'closed' : 'open';
});

document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;

  document.querySelectorAll(BADGE_SELECTOR).forEach(badge => {
    if (isShown(badge)) badge.dataset[STATE] = 'closed';
  });
});

document.addEventListener('focusout', event => {
  const badge = event.target.closest?.(BADGE_SELECTOR);
  if (badge) reset(badge);
});

document.addEventListener('pointerout', event => {
  if (event.pointerType !== 'mouse') return;

  const badge = event.target.closest?.(BADGE_SELECTOR);
  if (badge && !badge.contains(event.relatedTarget)) reset(badge);
});
